module.exports = __webpack_public_path__ + "img/05087039000101.674fa6ae.png";